import { render, staticRenderFns } from "./spop.vue?vue&type=template&id=5e9b2086&"
import script from "./spop.vue?vue&type=script&lang=js&"
export * from "./spop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports